import React from 'react'
import {
  IBuilderLibraries,
  IConfigurableBuilder,
  IStupidEdiConfigs,
  ITransactionSetWithSubtype,
  Maybe,
} from 'types/graphqlTypes'
import { tfx12Config } from '../../EdiSelfService/types'
import { EditBuilderContainer } from './EditBuilderContainer'
import { RunBuilderContainer } from './RunBuilderContainer'

interface IQueryContainerProps {
  displayUserFeedback: (message: string, level?: 'error' | 'info') => void
  extractionTemplate: string
  setExtractionTemplate: (value: string) => void
  builderLibrary: IBuilderLibraries
  setBuilderLibrary: (value: IBuilderLibraries) => void
  stupidediConfig: Maybe<IStupidEdiConfigs>
  setStupidediConfig: (value: Maybe<IStupidEdiConfigs>) => void
  stupidediConfigOptions: string[]
  tfx12DefinitionId: Maybe<string>
  setTfx12DefinitionId: (value: Maybe<string>) => void
  tfx12ConfigOptions: tfx12Config[]
  runBuilderSettingsClickHandler: () => void
  runQueryHandler: (
    extractionTemplate: string,
    builderLibrary: IBuilderLibraries,
    stupidediConfig: Maybe<IStupidEdiConfigs>,
    tfx12DefinitionId: Maybe<string>
  ) => void
  selectedBuilder: IConfigurableBuilder | null
  outboundConfigId: string
  builderVersionId: string | null
  canBuildBalanceDues: boolean
  setCanBuildBalanceDues: (value: boolean) => void
  transactionSetWithSubtype: ITransactionSetWithSubtype
}

export const QueryContainer = ({
  builderLibrary,
  builderVersionId,
  canBuildBalanceDues,
  displayUserFeedback,
  extractionTemplate,
  outboundConfigId,
  runBuilderSettingsClickHandler,
  runQueryHandler,
  selectedBuilder,
  setBuilderLibrary,
  setCanBuildBalanceDues,
  setExtractionTemplate,
  setStupidediConfig,
  setTfx12DefinitionId,
  stupidediConfig,
  stupidediConfigOptions,
  tfx12ConfigOptions,
  tfx12DefinitionId,
  transactionSetWithSubtype,
}: IQueryContainerProps) => {
  if (selectedBuilder) {
    return (
      <EditBuilderContainer
        displayUserFeedback={displayUserFeedback}
        extractionTemplate={extractionTemplate}
        extractionTemplateChangeHandler={setExtractionTemplate}
        builderLibrary={builderLibrary}
        builderLibraryChangeHandler={setBuilderLibrary}
        stupidediConfig={stupidediConfig}
        stupidediConfigChangeHandler={setStupidediConfig}
        stupidediConfigOptions={stupidediConfigOptions}
        tfx12DefinitionId={tfx12DefinitionId}
        tfx12DefinitionIdChangeHandler={setTfx12DefinitionId}
        tfx12ConfigOptions={tfx12ConfigOptions}
        runQueryHandler={runQueryHandler}
        settingsClickHandler={runBuilderSettingsClickHandler}
        selectedBuilderId={selectedBuilder.id}
        outboundConfigId={outboundConfigId}
        builderVersionId={builderVersionId}
        canBuildBalanceDues={canBuildBalanceDues}
        canBuildBalanceDuesChangeHandler={setCanBuildBalanceDues}
        transactionSetWithSubtype={transactionSetWithSubtype}
      />
    )
  }

  return (
    <RunBuilderContainer
      extractionTemplate={extractionTemplate}
      builderLibrary={builderLibrary}
      stupidediConfig={stupidediConfig}
      tfx12DefinitionId={tfx12DefinitionId}
      extractionTemplateChangeHandler={setExtractionTemplate}
      runQueryHandler={runQueryHandler}
      settingsClickHandler={runBuilderSettingsClickHandler}
    />
  )
}
